import { Navigate, Outlet } from "react-router-dom";
import { STORAGE_TOKEN } from "../constants";
import { useEffect, useState } from "react";
import PageLoader from "../components/common/PageLoader";

export default function Root() {
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem(STORAGE_TOKEN);
    setToken(storedToken);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div data-testid="loading-indicator">
        <PageLoader />
      </div>
    );
  }

  if (token) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <>
      {/* all the other elements */}
      <div id="detail">
        <Outlet />
      </div>
    </>
  );
}
